import AuthHelper from "../../../../common/helpers/AuthHelper";
import CustomerService from "../../../../common/services/customer/CustomerService";
import ServiceCenterService from "../../../../common/services/customer/ServiceCenterService";
import { UPDATE_AUTH_CUSTOMER_INFO } from "../../../authentication/store/actions";
import { UPDATE_STATUS } from "../listing/actions";
import {
    ADD_SHIPPING_ADDRESS,
    CREATE_BILLING_ADDRESS,
    GET_BILLING_ADDRESS,
    GET_SHIPPING_ADDRESSES,
    UPDATE_BILLING_ADDRESS,
    UPDATE_CUSTOMER_INFO,
    UPDATE_SHIPPING_ADDRESS,
    CREATE_SHIPPING_ADDRESS,
    CREATE_SERVICE_CENTER,
    EDIT_SERVICE_CENTER,
    GET_SERVICE_CENTER,
    VALIDATE_VAT,
} from "./actions";

export default {
    /**
     * TODO change the state variable names and getters  to camelCase
     */
    state: {
        shippingAddresses: [],
        billingAddress: [],
        serviceCenterAddress: {
            brands:[],
            categories:[]
        },
    },
    getters: {
        shippingAddresses: (state) => {
            return state.shippingAddresses;
        },
        billingAddress: (state) => {
            return state.billingAddress;
        },
        serviceCenterAddress: (state) => {
            return state.serviceCenterAddress;
        },
    },
    mutations: {
        [GET_SHIPPING_ADDRESSES]: (state, data) => {
            state.shippingAddresses = data;
        },
        [GET_BILLING_ADDRESS]: (state, data) => {
            state.billingAddress = data;
        },
        [GET_SERVICE_CENTER]: (state, data) => {
            state.serviceCenterAddress = data;
        },
        [UPDATE_BILLING_ADDRESS]: async(state, data) => {
            state.billingAddress = data;
        },
        [UPDATE_SHIPPING_ADDRESS]: (state, data) => {
            state.shippingAddresses.forEach(function(item, index) {
                if (item.id == data.id) state.shippingAddresses[index] = data;
            });
        },
        [ADD_SHIPPING_ADDRESS]: (state, data) => {
            state.shippingAddresses.push(state);
        },
        getServiceCenter:(state, data)=>{
            state.serviceCenterAddress = data
        }
    },
    actions: {
        [CREATE_BILLING_ADDRESS]: async(context, data) => {
            if (!AuthHelper.checkAuthForAction(context)) return;
            var customerService = new CustomerService();
            var result = await customerService.createBillingAddress(
                context.getters.customer.id,
                data
            );
            context.commit(GET_BILLING_ADDRESS, result.data);
        },
        [UPDATE_BILLING_ADDRESS]: async(context, data) => {
            if (!AuthHelper.checkAuthForAction(context)) return;
            var customerService = new CustomerService();
            var result = await customerService.updateBillingAddress(
                context.getters.customer.id,
                data
            );
            context.commit(GET_BILLING_ADDRESS, result.data.data);
        },

        [CREATE_SERVICE_CENTER]: async(context, data) => {
            console.log("Creating")
            console.log(data)
            var serviceCenterService = new ServiceCenterService();
            await serviceCenterService.create(data)
        },
        [EDIT_SERVICE_CENTER]: async(context, data) => {
            console.log("Editing")
            console.log(data)

            var serviceCenterService = new ServiceCenterService();
            await serviceCenterService.edit(data)
        },

        [GET_SERVICE_CENTER]: async(context)=>{
            var serviceCenterService = new ServiceCenterService();
            var result = await serviceCenterService.fintByCustomerId()
            context.commit('getServiceCenter', result.data)
            return result
        },

        [CREATE_SHIPPING_ADDRESS]: async(context, data) => {
            var customerService = new CustomerService();
            var result = await customerService.createShippingAddress(
                context.getters.customer.id,
                data
            );
            context.commit(ADD_SHIPPING_ADDRESS, result.data);
        },
        [UPDATE_SHIPPING_ADDRESS]: async(context, data) => {
            var customerService = new CustomerService();
            var result = await customerService.updateShippingAddress(
                context.getters.customer.id,
                data
            );
            context.commit(UPDATE_SHIPPING_ADDRESS, result.data.data);
        },
        [GET_SHIPPING_ADDRESSES]: async(context) => {
            var customerService = new CustomerService();
            var result = await customerService.getShippingAddresses(
                context.getters.customer.id
            );
            context.commit(GET_SHIPPING_ADDRESSES, result.data.data);
            return result.data.data;
        },
        [GET_BILLING_ADDRESS]: async(context) => {
            var customerService = new CustomerService();
            var result = await customerService.getBillingAddress(
                context.getters.customer.id
            );
            var billing = result.data.data;
            billing = billing == undefined ? {} : billing;
            context.commit(GET_BILLING_ADDRESS, billing);
            if(!context.getters.billingAddress.first_name && context.getters.billingAddress.first_name!=="")
            {
                context.state.billingAddress['first_name'] = context.getters.customer.first_name
            }

            if(!context.getters.billingAddress.last_name && context.getters.billingAddress.last_name!=="")
            {
                context.state.billingAddress['last_name'] = context.getters.customer.last_name
            }

            if(!context.getters.billingAddress.email && context.getters.billingAddress.email!=="")
            {
                context.state.billingAddress['email'] = context.getters.customer.email
            }
            return billing;
        },
        [UPDATE_CUSTOMER_INFO]: async(context, data) => {
            var customerService = new CustomerService();
            var result = await customerService.edit(data);
            context.commit(UPDATE_AUTH_CUSTOMER_INFO, result.data);
        },
        [VALIDATE_VAT]: async(context, data) => {
            var customerService = new CustomerService();
            var result = await customerService.validateVat(data);
            return result.data;
        },
    },
};